import { Outlet, createRootRouteWithContext, useRouterState } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";

import { TopBar } from "@/components/shared/TopBar";
import { LeftNav } from "@/components/shared/LeftNav";
import { AuthGate } from "@/components/auth/AuthGate";

export interface RouterContext {
  queryClient: QueryClient;
}

const PUBLIC_PATHS = new Set<string>(["/login"]);

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (PUBLIC_PATHS.has(pathname)) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Outlet />
      </div>
    );
  }

  if (pathname === "/force-change-password") {
    return (
      <AuthGate>
        <div className="flex h-screen items-center justify-center bg-background">
          <Outlet />
        </div>
      </AuthGate>
    );
  }

  return (
    <AuthGate>
      <div className="flex h-screen flex-col">
        <TopBar />
        <div className="flex flex-1 overflow-hidden">
          <LeftNav />
          <main className="flex-1 overflow-auto min-h-0">
            <Outlet />
          </main>
        </div>
      </div>
    </AuthGate>
  );
}
